import loadable from "@loadable/component";

const InboxComponent = loadable(() => import("../../components/Inbox"));

export const Inbox = () => {
  return (
    <>
      <InboxComponent />
    </>
  );
};
